import React from "react";
import {Button, Card} from '@mui/material/';
import mentor_pic from './../mentor_pic.jpeg';
import { useLocation } from 'react-router-dom';
import * as constants from './../constants'

export default function SessionDetails() {

    const location = useLocation();

    const addToCalendar = () => {
        // todo : add code to add this appointment to google calendar
        return true
    }

    return (
        location.state ?
        <div className="screen center-align">
            <div className="center-align font-20">You are all set!</div>
            <Card className="mentor-card" sx={{m:2}}>
                <p className="center-align font-18">Mentor Session</p>
                <div className="col-center primary-color">
                    <div className="center-align font-16">Date: {location.state.date}</div>
                    <div className="center-align font-16">Time: {location.state.time}</div>
                    <div className="center-align font-16">Duration: {location.state.duration}</div>

                </div>
                <div className="center-align font-14">with</div>
                <div className="center-align font-16">{location.state.mentor.name}</div>
                <img
                src={mentor_pic}
                alt="Not Found"
                className="circle"
                />
                <div className="button-group center-align">
                    <Button className="m-form-button" variant="outlined" onClick={addToCalendar}>Add to Calendar</Button>
                </div>
            </Card>
        </div> : null
    )
}
